import { PageContainer } from '../../../shared/PageContainer';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import { PageDefaultSegment, useFeedback } from "@sis/react-library";
import { useState } from 'react';
import { FormSamplesOutput } from '../FormSamplesOutput';
import { callMimicApi } from '../../../../utils/commonUtils';
import { FormSamplesInitialValuesForm } from './FormSamplesInitialValuesForm';
import { FormSamplesInitialValuesPageInfo } from './FormSamplesInitialValuesPageInfo';

/////////////////////////////////////////////////////////////////////////////////////////////
// Existing interface (would be defined elsewhere in the project).
/////////////////////////////////////////////////////////////////////////////////////////////
export interface ExampleDto {
    id?: number;
    firstName: string;
    lastName: string;
    isEmployed: boolean;
    phoneNo: string;
}
export const FormSamplesInitialValuesPage = () => {

    /////////////////////////////////////////////////////////////////////////////////////////////
    // The initial values for the form.
    // This is passed as props to the form in the FormSamplesInitialValuesForm component.
    /////////////////////////////////////////////////////////////////////////////////////////////
    const initialValuesToBePassed: ExampleDto = {
        id: 28,
        firstName: 'Test',
        lastName: 'User',
        isEmployed: true,
        phoneNo: '(072) 222-44224'
    }

    const [submittedValues, setSubmittedValues] = useState<ExampleDto | undefined>(undefined)
    const [submitting, setSubmitting] = useState(false);
    const { showError } = useFeedback();

    const handleSubmit = async (values: ExampleDto) => {
        setSubmitting(true);
        setSubmittedValues(values);

        try {
            // In the api call, uncomment the exception in there to test errors coming from the api
            await callMimicApi();
        } catch (ex) {
            showError(`An error occured: ${ex}`);
            return false;
        } finally {
            setSubmitting(false);
        }
    }

    return (
        <PageContainer
            heading='Form Samples - Initial Values'
            icon={<TextSnippetIcon />}
            pageInfo={<FormSamplesInitialValuesPageInfo />}
            wrapRightElementForMobile={false}
        >
            <PageDefaultSegment width={400}>
                <FormSamplesInitialValuesForm
                    initialValues={initialValuesToBePassed}
                    submitting={submitting}
                    onSubmit={handleSubmit}
                />
            </PageDefaultSegment>
            <FormSamplesOutput width={400} submittedValues={submittedValues} />
        </PageContainer>
    )
}
